import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import {
  MigrationProgress,
  MigrationRequest,
  MigrationStartResponse,
  EntityMigrationResult
} from '../../interface/ledger/ledger-system';

@Injectable({
  providedIn: 'root'
})
export class LedgerMigrationService {
  constructor(private http: HttpService) { }

  // Migration operations
  async migrateAllData(request?: MigrationRequest): Promise<MigrationStartResponse> {
    const body = request || {};
    return firstValueFrom(this.http.post('/ledgermigration/start', body));
  }

  async getMigrationProgress(batchId: string): Promise<MigrationProgress> {
    return firstValueFrom(this.http.get(`/ledgermigration/progress/${batchId}`));
  }

  async migrateCustomer(customerId: number): Promise<EntityMigrationResult> {
    return firstValueFrom(this.http.post(`/ledgermigration/customers/${customerId}`, {}));
  }

  async migrateSupplier(supplierId: number): Promise<EntityMigrationResult> {
    return firstValueFrom(this.http.post(`/ledgermigration/suppliers/${supplierId}`, {}));
  }
}
